import React from "react";

import * as S from "./styles";
import { IProps } from "./types";

export const Checkbox: React.FC<IProps> = ({
  name,
  checked,
  onChange = () => null,
  children,
  ...props
}: IProps) => {
  return (
    <S.Checkbox onClick={evt => evt.stopPropagation()}>
      <input
        {...props}
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
      />
      <S.Label aria-hidden="true">
        <div>
          <span></span>
        </div>
      </S.Label>
      <S.Text>{children}</S.Text>
    </S.Checkbox>
  );
};
